import {axiosClient} from "./client";
import {EXPERT_LESSON_HISTORY, EXPERT_PAYMENT_HISTORY} from "./client/endpoints";
import {LessonsRevenuePayload} from "../redux/models/revenue";

const getLessonsRevenueHistory = async (data: LessonsRevenuePayload): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(EXPERT_LESSON_HISTORY, data);
    return response.data;
  } catch (e) {
    return null;
  }
};

const getPaymentHistory = async (data: LessonsRevenuePayload): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(EXPERT_PAYMENT_HISTORY, data);
    return response.data;
  } catch (e) {
    return null;
  }
};

const ExpertRevenueManagementService = {
  getLessonsRevenueHistory,
  getPaymentHistory
};

export default ExpertRevenueManagementService;